import { UserContext as getUserInfo } from '@qpr/client-library';
import React, { useState } from 'react';
import api from '../../../api/api-caller';
import { ApiEndpoint } from '../../../api/api-consts';
import UserMenu from '../components/UserMenu';

export default () => {
  const [landingPage, setLandingPage] = useState({
    url: getUserInfo().landingUrl,
    title: getUserInfo().landingTitle
  });

  const logoutHandler = () => {
    const doLogout = async () => {
      await api.asyncCallApi(ApiEndpoint.logout, {
        method: 'POST',
        options: { resetSessionToken: true }
      });
      location.pathname = '/logout';
    };

    doLogout();
  };

  const landingUrlHandler = (
    profileId: string = '',
    landingUrl: string = '',
    landingTitle: string | null = ''
  ) => {
    const putLandingPage = async () => {
      await api.asyncCallApi(`${ApiEndpoint.profiles}/${profileId}`, {
        method: 'PUT',
        body: { landingUrl, landingTitle }
      });
    };
    putLandingPage();
    setLandingPage({
      url: landingUrl,
      title: landingTitle || landingUrl
    });
  };
  getUserInfo().landingUrl = landingPage.url;
  getUserInfo().landingTitle = landingPage.title;

  return (
    <UserMenu
      userInfo={getUserInfo()}
      handleLogOut={logoutHandler}
      handleLandingUrl={landingUrlHandler}
    />
  );
};
